import { useState } from 'react';
import useIsomorphicLayoutEffect from './bundle.esm.js';

const useWindowSize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  useIsomorphicLayoutEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const updateSize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
};

export { useWindowSize as default };
//# sourceMappingURL=bundle.esm3.js.map
